let maplibrePromise: Promise<typeof import('maplibre-gl')> | null = null;

export function loadMapLibre(): Promise<typeof import('maplibre-gl')> {
  if (!maplibrePromise) {
    maplibrePromise = import('maplibre-gl').catch((error) => {
      maplibrePromise = null;
      throw error;
    });
  }
  return maplibrePromise;
}
